<template>
  <SideMenuBase :menuGroups="menuGroups" />
</template>

<script setup>
import SideMenuBase from '@/components/layout/SideMenuBase.vue'

const menuGroups = [
  {
    title: 'Home',
    items: [
      { label: 'Release Notes', path: '/home/release-notes' },
      { label: 'About', path: '/home/about' }
    ]
  }
]
</script>
